export default __webpack_public_path__ + "static/media/iconesAquisiçõesXMaior.50f06b73.png";